import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'mapfre-label',
  templateUrl: './mapfre-label.component.html'
})
export class MapfreLabelComponent{
  @Input() forInput:            string;
  @Input() validationCSSClass:  boolean;
  @Input() additionalClasses: string;

}
